const cleanBase64 = (base64) => base64.split(',')[1]

export default cleanBase64
